import ResortLandingPage from "@/components/ResortLandingPage";

const PremiumGavResorts = () => {
  return (
    <ResortLandingPage
      developmentSlug="premium-gav-resorts"
      title="Premium GAV Resorts"
      subtitle="Resort em Salinopolis com parque aquatico integrado, lazer completo e estrutura moderna a poucos minutos da praia."
      cityState="Salinopolis/PA"
      description="O Premium GAV Resorts foi pensado para unir descanso e diversao no litoral paraense. O complexo conta com opcoes para familias, casais e grupos, incluindo areas de lazer, gastronomia e acomodações confortaveis para estadias curtas ou prolongadas."
      bannerPath="/empreendimentos/premium-gav-banner.png"
      galleryPaths={[
        "/empreendimentos/premium-gav-banner.png",
        "/empreendimentos/premium-gav-galeria-1.jpg",
        "/empreendimentos/premium-gav-galeria-2.jpg",
      ]}
      address="PA-444, Estrada do Atalaia"
      bookingPhone="0800 300 6565"
      whatsapp="(62) 3773-9600"
      email="reservas@gavresorts.com.br"
    />
  );
};

export default PremiumGavResorts;
